import Navbar from './NavbarES';
import Footer from './FooterES';
import { subDays, addDays, setHours, setMinutes, getDay, format, startOfMonth, endOfMonth, eachDayOfInterval, isSameMonth, isSameDay, addMonths, subMonths, startOfDay } from 'date-fns';
import { useState, useEffect } from "react";
import { InfinitySpin } from 'react-loader-spinner';
import axios from 'axios';
import Wpp from '../Wpp';
import { Calendar, Clock, User, Phone, Mail, MessageSquare, CheckCircle, ArrowRight, ChevronLeft, ChevronRight } from 'react-feather';

function Appointments() {

    const [startDate, setStartDate] = useState(() => {
        const tomorrow = addDays(new Date(), 1);
        const dayOfWeek = getDay(tomorrow);
        // If tomorrow is weekend, find next Monday
        if (dayOfWeek === 0) { // Sunday
            return addDays(tomorrow, 1); // Monday
        } else if (dayOfWeek === 6) { // Saturday
            return addDays(tomorrow, 2); // Monday
        }
        return tomorrow;
    });
    const [scheduleBtn, setScheduleBtn] = useState("Schedule now");
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [loadingBackground, setLoadingBackground] = useState('');
    const [name, setName] = useState('');
    const [lName, setLName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [text, setText] = useState('');
    const [selector, setSelector] = useState('');
    const [time, setTime] = useState('09.00 AM');
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
    const [bookedTimes, setBookedTimes] = useState([]);
    const [loadingAvailability, setLoadingAvailability] = useState(false);
    const [currentMonth, setCurrentMonth] = useState(() => {
        const today = new Date();
        const tomorrow = addDays(today, 1);
        const dayOfWeek = getDay(tomorrow);
        // If tomorrow is weekend, start with next Monday's month
        if (dayOfWeek === 0) { // Sunday
            return addDays(tomorrow, 1);
        } else if (dayOfWeek === 6) { // Saturday
            return addDays(tomorrow, 2);
        }
        return tomorrow;
    });

    // API proxied through Nginx - uses same domain and SSL cert
    const api_url = window.location.origin;

    // Available time slots
    const timeSlots = [
        { time: '09.00 AM', label: '9:00 AM EST' },
        { time: '09.30 AM', label: '9:30 AM EST' },
        { time: '10.00 AM', label: '10:00 AM EST' },
        { time: '10.30 AM', label: '10:30 AM EST' },
        { time: '11.00 AM', label: '11:00 AM EST' },
        { time: '11.30 AM', label: '11:30 AM EST' },
        { time: '01.00 PM', label: '1:00 PM EST' },
        { time: '01.30 PM', label: '1:30 PM EST' },
        { time: '02.00 PM', label: '2:00 PM EST' },
        { time: '02.30 PM', label: '2:30 PM EST' },
        { time: '03.00 PM', label: '3:00 PM EST' },
        { time: '03.30 PM', label: '3:30 PM EST' },
        { time: '04.00 PM', label: '4:00 PM EST' },
        { time: '04.30 PM', label: '4:30 PM EST' },
        { time: '05.00 PM', label: '5:00 PM EST' },
        { time: '05.30 PM', label: '5:30 PM EST' },
        { time: '06.00 PM', label: '6:00 PM EST' },
        { time: '06.30 PM', label: '6:30 PM EST' },
        { time: '07.00 PM', label: '7:00 PM EST' },
    ];

    function ScheduleBtn() {
        if (loading == false && emailSent == false) {
            return (
                <button 
                    className="btn btn-primary fw-500" 
                    onClick={(e) => send()} 
                    style={{ 
                        backgroundColor: '#64a19d', 
                        border: 'none', 
                        padding: '15px 30px', 
                        borderRadius: '12px',
                        fontSize: '16px',
                        fontWeight: '600',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(100, 161, 157, 0.3)'
                    }}  
                    disabled={!name || !lName || !phone || !email || !selectedTimeSlot}
                    type="submit"
                >
                    <CheckCircle size={18} style={{ marginRight: '8px' }} />
                    Reservar Consulta Gratuita
                </button>
            )
        } else if(emailSent == true && loading == false){
            return(
                <div style={{
                    textAlign:'center', 
                    color:'#10b981', 
                    padding: '20px',
                    backgroundColor: '#f0fdf4',
                    borderRadius: '12px',
                    border: '2px solid #10b981'
                }}>
                    <CheckCircle size={24} style={{ marginBottom: '10px' }} />
                    <div style={{ fontWeight: '600', marginBottom: '5px' }}>¡Cita Confirmada!</div>
                    <div style={{ fontSize: '14px', color: '#059669' }}>Por favor revisa tu correo para más detalles.</div>
                </div>
            )
        } else if(loading == true) {
            return (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <InfinitySpin color="#64a19d" />
                    <div style={{ marginTop: '10px', color: '#64a19d' }}>Programando tu cita...</div>
                </div>
            )
        }
    }

    const send = () => {
        // First check if the time slot is still available
        checkAvailability(startDate).then(() => {
            if (bookedTimes.includes(selectedTimeSlot)) {
                alert("Lo sentimos, este horario acaba de ser reservado por otra persona. Por favor selecciona un horario diferente.");
                return;
            }

            setLoading(true);
            setTime(selectedTimeSlot);

            axios({
                method:'POST',
                url:api_url+'/api/send_appointment',
                data:{
                    name,
                    lName,
                    phone,
                    email,
                    selector,
                    text,
                    startDate,
                    time: selectedTimeSlot
            }
            }).then(res => {
                console.log("Email status "+res.status);
                if(res.status === 200){
                    setLoading(false);
                    setEmailSent(true);
                    // Refresh availability after successful booking
                    checkAvailability(startDate);
                }else{
                    setLoading(false);
                    alert("Hubo un problema al reservar la cita. Por favor intenta de nuevo. Gracias.");
                }
            }).catch(error => {
                console.log("Error booking appointment:", error);
                setLoading(false);
                alert("Hubo un problema al reservar la cita. Por favor intenta de nuevo. Gracias.");
            });
        });
    }

    useEffect(() => {
        // Reset time selection when date changes
        setSelectedTimeSlot(null);
        setBookedTimes([]);
        
        // Check availability for the selected date
        if (startDate) {
            checkAvailability(startDate);
        }
    }, [startDate])

    // Periodic refresh of availability (every 30 seconds)
    useEffect(() => {
        if (!startDate) return;
        
        const interval = setInterval(() => {
            checkAvailability(startDate);
        }, 30000); // 30 seconds

        return () => clearInterval(interval);
    }, [startDate]);

    const checkAvailability = async (date) => {
        setLoadingAvailability(true);
        try {
            const response = await axios.get(`${api_url}/api/check_availability`, {
                params: { date: date.toISOString() }
            });
            setBookedTimes(response.data.bookedTimes || []);
        } catch (error) {
            console.error('Error checking availability:', error);
            // Temporary fallback: manually mark 11:00 AM as booked for testing
            const today = new Date();
            const selectedDay = format(date, 'yyyy-MM-dd');
            const todayStr = format(today, 'yyyy-MM-dd');
            
            if (selectedDay === todayStr) {
                // If checking today's availability, mark 11:00 AM as booked
                setBookedTimes(['11.00 AM']);
            } else {
                setBookedTimes([]);
            }
        } finally {
            setLoadingAvailability(false);
        }
    };

    const isWeekday = (date) => {
        const day = getDay(date);
        // 0 = Sunday, 6 = Saturday - we want weekdays (1-5) to be available
        // Monday = 1, Tuesday = 2, Wednesday = 3, Thursday = 4, Friday = 5
        return day >= 1 && day <= 5;
    };

    const handleTimeSlotClick = (slot) => {
        // Only allow selection if the slot is not booked
        if (!bookedTimes.includes(slot.time)) {
            setSelectedTimeSlot(slot.time);
        }
    };

    // Custom Calendar Component
    const CustomCalendar = () => {
        const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(currentMonth);
        const startDate_cal = monthStart;
        const endDate_cal = monthEnd;
        
        // Get the first day of the month and calculate padding
        const firstDayOfMonth = getDay(monthStart);
        const days = eachDayOfInterval({ start: startDate_cal, end: endDate_cal });
        
        // Add empty cells for days before the month starts
        const calendarDays = [];
        for (let i = 0; i < firstDayOfMonth; i++) {
            calendarDays.push(null);
        }
        calendarDays.push(...days);

        const nextMonth = () => setCurrentMonth(addMonths(currentMonth, 1));
        const prevMonth = () => setCurrentMonth(subMonths(currentMonth, 1));

        const handleDateClick = (day) => {
            // Only allow selection of weekdays that are in the future
            const tomorrow = startOfDay(addDays(new Date(), 1));
            const dayStart = startOfDay(day);
            if (isWeekday(day) && dayStart >= tomorrow) {
                setStartDate(day);
            }
        };

        return (
            <div style={{
                backgroundColor: 'white',
                borderRadius: '16px',
                padding: '24px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                border: '1px solid #f1f5f9'
            }}>
                {/* Calendar Header */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px'
                }}>
                    <button
                        onClick={prevMonth}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: '8px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            color: '#64748b',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                        <ChevronLeft size={20} />
                    </button>
                    
                    <h3 style={{
                        margin: 0,
                        fontSize: '18px',
                        fontWeight: '600',
                        color: '#1e293b'
                    }}>
                        {format(currentMonth, 'MMMM yyyy')}
                    </h3>
                    
                    <button
                        onClick={nextMonth}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: '8px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            color: '#64748b',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                        <ChevronRight size={20} />
                    </button>
                </div>

                {/* Day Headers */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '8px',
                    marginBottom: '16px'
                }}>
                    {['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'].map(day => (
                        <div key={day} style={{
                            textAlign: 'center',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#64748b',
                            padding: '8px 4px'
                        }}>
                            {day}
                        </div>
                    ))}
                </div>

                {/* Calendar Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '4px'
                }}>
                    {calendarDays.map((day, index) => {
                        // Handle empty cells for padding
                        if (day === null) {
                            return (
                                <div key={`empty-${index}`} style={{ minHeight: '44px' }} />
                            );
                        }

                        const isSelected = isSameDay(day, startDate);
                        const isToday = isSameDay(day, new Date());
                        // Fix: Use startOfDay to compare dates properly and avoid timezone issues
                        const tomorrow = startOfDay(addDays(new Date(), 1));
                        const dayStart = startOfDay(day);
                        const isDisabled = !isWeekday(day) || dayStart < tomorrow;
                        const isOtherMonth = !isSameMonth(day, currentMonth);

                        return (
                            <button
                                key={index}
                                onClick={() => handleDateClick(day)}
                                disabled={isDisabled}
                                style={{
                                    background: isSelected ? '#64a19d' : 
                                              isToday ? '#f0fdf4' : 
                                              isOtherMonth ? '#f8fafc' : 'white',
                                    border: isSelected ? '2px solid #64a19d' : 
                                           isToday ? '2px solid #10b981' : 
                                           '2px solid transparent',
                                    borderRadius: '12px',
                                    padding: '12px 8px',
                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    fontWeight: isSelected ? '600' : '500',
                                    color: isSelected ? 'white' : 
                                           isDisabled ? '#cbd5e1' : 
                                           isOtherMonth ? '#cbd5e1' : '#1e293b',
                                    transition: 'all 0.2s ease',
                                    minHeight: '44px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isDisabled) {
                                        e.target.style.transform = 'scale(1.05)';
                                        e.target.style.boxShadow = '0 4px 12px rgba(100, 161, 157, 0.2)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            >
                                {format(day, 'd')}
                                {isToday && !isSelected && (
                                    <div style={{
                                        position: 'absolute',
                                        bottom: '4px',
                                        width: '4px',
                                        height: '4px',
                                        backgroundColor: '#10b981',
                                        borderRadius: '50%'
                                    }} />
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* Calendar Legend */}
                <div style={{
                    marginTop: '16px',
                    padding: '12px',
                    backgroundColor: '#f8fafc',
                    borderRadius: '8px',
                    fontSize: '12px',
                    color: '#64748b'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                        <div style={{
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#64a19d',
                            borderRadius: '50%',
                            marginRight: '8px'
                        }} />
                        Fecha Seleccionada
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                        <div style={{
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#10b981',
                            borderRadius: '50%',
                            marginRight: '8px'
                        }} />
                        Hoy
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#cbd5e1',
                            borderRadius: '50%',
                            marginRight: '8px'
                        }} />
                        No Disponible (Fines de Semana/Pasado)
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Navbar />
            <div id="layoutDefault">
                <div id="layoutDefault_content">
                    <main>
                        <header className="page-header-ui page-header-ui-dark bg-gradient-primary-to-secondary" style={{ minHeight: '100vh' }}>
                            <div className="page-header-ui-content">
                                <div className="container px-5">
                                    <div className="row gx-5 align-items-start">
                                        <div className="col-lg-6">
                                            <div style={{
                                                position: 'sticky',
                                                top: '100px',
                                                zIndex: 10,
                                                height: 'fit-content'
                                            }}>
                                                <div className="badge badge-marketing rounded-pill bg-secondary-soft text-secondary mb-3">
                                                    <Calendar size={16} style={{ marginRight: '6px' }} />
                                                    Consulta Gratuita
                                                </div>
                                                <h1 className="page-header-ui-title">Reserva Tu Consulta Fiscal Gratuita</h1>
                                                <p className="page-header-ui-text">Obtén asesoramiento experto en planificación fiscal, formación de empresas y estrategias financieras. Nuestros especialistas están aquí para ayudarte a maximizar tus oportunidades.</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="card rounded-3 text-dark" style={{ 
                                                border: 'none', 
                                                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                                borderRadius: '20px'
                                            }}>
                                                <div className="card-header py-4" style={{ 
                                                    backgroundColor: '#f8fafc', 
                                                    borderBottom: '1px solid #e2e8f0',
                                                    borderRadius: '20px 20px 0 0',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    fontSize: '18px',
                                                    color: '#1e293b'
                                                }}>
                                                    <Calendar size={20} style={{ marginRight: '8px', color: '#64a19d' }} />
                                                    Programa Tu Consulta Gratuita
                                                </div>
                                                <div className="card-body p-4">
                                                    {/* Personal Information */}
                                                    <div className="row gx-3 mb-4">
                                                        <div className="col-md-6">
                                                            <label className="small text-gray-600 mb-2 d-block">
                                                                <User size={14} style={{ marginRight: '4px' }} />
                                                                Nombre
                                                            </label>
                                                            <input 
                                                                className="form-control" 
                                                                type="text" 
                                                                onChange={e => setName(e.target.value)}
                                                                style={{ 
                                                                    borderRadius: '10px', 
                                                                    border: '1px solid #e2e8f0',
                                                                    padding: '12px 16px'
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="small text-gray-600 mb-2 d-block">
                                                                <User size={14} style={{ marginRight: '4px' }} />
                                                                Apellido
                                                            </label>
                                                            <input 
                                                                className="form-control" 
                                                                type="text" 
                                                                onChange={e => setLName(e.target.value)}
                                                                style={{ 
                                                                    borderRadius: '10px', 
                                                                    border: '1px solid #e2e8f0',
                                                                    padding: '12px 16px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row gx-3 mb-4">
                                                        <div className="col-md-6">
                                                            <label className="small text-gray-600 mb-2 d-block">
                                                                <Phone size={14} style={{ marginRight: '4px' }} />
                                                                Teléfono
                                                            </label>
                                                            <input 
                                                                className="form-control" 
                                                                type="tel" 
                                                                onChange={e => setPhone(e.target.value)}
                                                                style={{ 
                                                                    borderRadius: '10px', 
                                                                    border: '1px solid #e2e8f0',
                                                                    padding: '12px 16px'
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="small text-gray-600 mb-2 d-block">
                                                                <Mail size={14} style={{ marginRight: '4px' }} />
                                                                Correo Electrónico
                                                            </label>
                                                            <input 
                                                                className="form-control" 
                                                                type="email" 
                                                                onChange={e => setEmail(e.target.value)}
                                                                style={{ 
                                                                    borderRadius: '10px', 
                                                                    border: '1px solid #e2e8f0',
                                                                    padding: '12px 16px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="mb-4">
                                                        <label className="small text-gray-600 mb-2 d-block">
                                                            <MessageSquare size={14} style={{ marginRight: '4px' }} />
                                                            Tipo de Servicio
                                                        </label>
                                                        <select 
                                                            className="form-control" 
                                                            onChange={e => setSelector(e.target.value)}
                                                            style={{ 
                                                                borderRadius: '10px', 
                                                                border: '1px solid #e2e8f0',
                                                                padding: '12px 16px'
                                                            }}
                                                        >
                                                            <option value="">Selecciona un servicio</option>
                                                            <option value="Tax Service">Preparación y Planificación Fiscal</option>
                                                            <option value="Business">Formación de Empresas y Consultoría</option>
                                                            <option value="Technology">Soluciones Tecnológicas</option>
                                                            <option value="Outsourcing">Servicios de Externalización</option>
                                                        </select>
                                                    </div>

                                                    <div className="mb-4">
                                                        <label className="small text-gray-600 mb-2 d-block">
                                                            <MessageSquare size={14} style={{ marginRight: '4px' }} />
                                                            Comentarios Adicionales
                                                        </label>
                                                        <textarea 
                                                            className="form-control" 
                                                            onChange={e => setText(e.target.value)}
                                                            rows="3"
                                                            placeholder="Cuéntanos sobre tus necesidades específicas..."
                                                            style={{ 
                                                                borderRadius: '10px', 
                                                                border: '1px solid #e2e8f0',
                                                                padding: '12px 16px',
                                                                resize: 'none'
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Date Selection */}
                                                    <div className="mb-4">
                                                        <label className="small text-gray-600 mb-3 d-block">
                                                            <Calendar size={14} style={{ marginRight: '4px' }} />
                                                            Seleccionar Fecha
                                                        </label>
                                                        <CustomCalendar />
                                                    </div>

                                                    {/* Time Selection */}
                                                    <div className="mb-4">
                                                        <label className="small text-gray-600 mb-3 d-block">
                                                            <Clock size={14} style={{ marginRight: '4px' }} />
                                                            Seleccionar Hora (EST)
                                                        </label>
                                                        <div style={{ 
                                                            border: '1px solid #e2e8f0', 
                                                            borderRadius: '15px', 
                                                            padding: '20px',
                                                            backgroundColor: '#f8fafc',
                                                            maxHeight: '300px',
                                                            overflowY: 'auto'
                                                        }}>
                                                            <div className="row g-2">
                                                                {loadingAvailability ? (
                                                                    <div className="col-12 text-center">
                                                                        <div style={{ padding: '20px', color: '#64a19d' }}>
                                                                            <InfinitySpin color="#64a19d" size={20} />
                                                                            <div style={{ marginTop: '10px', fontSize: '14px' }}>
                                                                                Verificando disponibilidad...
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    timeSlots.map((slot, index) => {
                                                                        const isBooked = bookedTimes.includes(slot.time);
                                                                        const isAvailable = !isBooked;
                                                                        
                                                                        return (
                                                                            <div key={index} className="col-6 col-md-4">
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => !isBooked && handleTimeSlotClick(slot)}
                                                                                    className={`btn w-100 ${
                                                                                        selectedTimeSlot === slot.time 
                                                                                            ? 'btn-primary' 
                                                                                            : isBooked 
                                                                                                ? 'btn-secondary' 
                                                                                                : 'btn-outline-secondary'
                                                                                    }`}
                                                                                    style={{
                                                                                        borderRadius: '10px',
                                                                                        padding: '10px 8px',
                                                                                        fontSize: '12px',
                                                                                        border: selectedTimeSlot === slot.time 
                                                                                            ? '2px solid #64a19d' 
                                                                                            : isBooked 
                                                                                                ? '1px solid #e5e7eb' 
                                                                                                : '1px solid #e2e8f0',
                                                                                        backgroundColor: selectedTimeSlot === slot.time 
                                                                                            ? '#64a19d' 
                                                                                            : isBooked 
                                                                                                ? '#f3f4f6' 
                                                                                                : 'transparent',
                                                                                        color: selectedTimeSlot === slot.time 
                                                                                            ? 'white' 
                                                                                            : isBooked 
                                                                                                ? '#9ca3af' 
                                                                                                : '#64748b',
                                                                                        transition: 'all 0.2s ease',
                                                                                        fontWeight: '500',
                                                                                        cursor: isBooked ? 'not-allowed' : 'pointer',
                                                                                        opacity: isBooked ? '0.6' : '1'
                                                                                    }}
                                                                                    disabled={isBooked}
                                                                                >
                                                                                    {slot.label}
                                                                                    {isBooked && (
                                                                                        <div style={{ 
                                                                                            fontSize: '10px', 
                                                                                            marginTop: '2px',
                                                                                            color: '#ef4444'
                                                                                        }}>
                                                                                            Reservado
                                                                                        </div>
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        );
                                                                    })
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="text-center">
                                                        <ScheduleBtn />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="svg-border-angled text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none" fill="currentColor"><polygon points="0,100 100,0 100,100"></polygon></svg>
                            </div>
                        </header>
                        <section className="bg-white border-bottom py-10">
                            <div className="container px-5">
                                <div className="row gx-5 align-items-center">
                                    <div className="col-lg-6 mb-4 mb-lg-0">
                                        <h4 className="text-primary">¿Tienes Preguntas?</h4>
                                        <p className="lead mb-0">¡Hablemos y discutamos tus necesidades!</p>
                                    </div>
                                    <div className="col-lg-6 text-lg-end">
                                        <a className="btn btn-primary fw-500 me-2" href="/contact">
                                            Contáctanos
                                            <ArrowRight size={16} style={{ marginLeft: '8px' }} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
            <Wpp />
            <Footer />
        </>
    )
}

export default Appointments;